import { render, staticRenderFns } from "./splashPage.vue?vue&type=template&id=1f08c196&scoped=true"
import script from "./splashPage.vue?vue&type=script&lang=js"
export * from "./splashPage.vue?vue&type=script&lang=js"
import style0 from "./splashPage.vue?vue&type=style&index=0&id=1f08c196&prod&scoped=true&lang=css"
import style1 from "./splashPage.vue?vue&type=style&index=1&id=1f08c196&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f08c196",
  null
  
)

export default component.exports